import React, { FC, ReactNode } from 'react';
import NextGenHeader from '../Header/next-gen-cart';
import { Main } from './LayoutStyled';
import Footer from '~/components/Footer';

interface Props {
  children: ReactNode;
}

const PageLayout: FC<Props> = ({ children }) => {
  return (
    <>
        <NextGenHeader />
        <Main>
            {children}
        </Main>
        <Footer />
    </>
  );
};

PageLayout.displayName = 'PageLayout';

export { PageLayout };
